/*
 *
 * Sider constants
 *
 */
const dir = 'sider';
const constant = type => `prodigalVoice/${dir}/${type}`;
export default constant;
export { dir };
